module.exports = __webpack_public_path__ + "img/yass-express-logo-invoice.fc85aada.svg";